<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <a href="#" role="button" @click.prevent.stop="openAlertModal()">キャンセル</a>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{dailyCheckButtonName}}</p>
                    <p class="menu_center_tex_l">{{dailyCheckPageName}}</p>
                </div>
                <div class="menu_right">
                    <a href="#" role="button" @click.prevent.stop="openAlertModal()"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>

        <div class="main_unit">
            <div class="top_unit">
                <div v-show="!isInitLoading"  class="top_center_box">{{page}}/{{totalPage}}</div>
                <div class="top_right_box_mgt">プレビュー表示</div>
            </div>

            <div>
                <div class="prev_box" v-if="page != 1">
                    <div class="box_fix">
                        <a href="#" role="button" @click.prevent.stop="openAlertModal()"><i class="fas fa-chevron-left prev_next_icn"></i><br>前</a>
                    </div>
                </div>
                <div class="next_box" v-if="page != totalPage">
                    <div class="box_fix">
                        <a href="#" role="button" @click.prevent.stop="openAlertModal()"><i class="fas fa-chevron-right prev_next_icn"></i><br>次</a>
                    </div>
                </div>
            </div>

            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="wd840" >

                    <div class="checkbox_single" style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;align-items: center;">
                        <div v-if="allButtonDisplayFlg === '1'">
                            <input type="checkbox" id="01-A" name="checkbox01" :checked="isAllSelected" @click="selectAllCats">
                            <label for="01-A" class="checkbox01" style="display: inline-block !important;">すべて確認</label>
                        </div>
                        <div v-else></div>
                        <p class="checkItem_comment_add_btn_top">コメント枠 追加</p>
                    </div>
                    <div class="checkbox_multiple">
                        <div v-for="(rule, index) in dailyCheckItemNames" :key="index">
                            <input type="checkbox" name="checkbox01" v-model="rule.value" :id="index"
                                   @click="selectItemClick(index)">
                            <label class="checkbox01" :for="index">
                              <div class="row justify-content-sm-between align-items-center" >
                                <span class="col-9">{{rule.name}}</span>
                                <div class="checkItem_comment_add_btn">
                                  <a href="#" @click.prevent.stop="commentDisplayFlgToggle(index)" v-show="!commentDisplayFlg[index]">+</a>
                                  <a href="#" @click.prevent.stop="commentDisplayFlgToggle(index)" v-show="commentDisplayFlg[index]">-</a>
                                </div>
                              </div>
                            </label>
                            <div v-show="commentDisplayFlg[index]" class="textarea_unit">
                              <textarea class="textarea_box3" placeholder="この項目のコメントを入力" maxlength="200"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="btnbox">
                        <ul>
                            <li v-for="n in arrangementRuleCount" :key="n">
                                <a href="#" role="button" @click.prevent.stop="openAlertModal()"><i>配置ルール</i></a>
                            </li>
                        </ul>
                    </div>
                    <div class="last_update" style="position: relative;">
                      最後の更新：
                        <div class="right_icn">
                            <a href="#" role="button" @click.prevent.stop="openAlertModal()">
                              <p class="icn_red"><i class="fas fa-info-circle"></i></p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="openAlertModal()">登録</a>
                </div>
            </div>
        </div>

        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>

        <AlertDialog :display="showModal.alertDisplay" @close="closeAlertModal"/>

    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import AlertDialog from '@/app/components/common/AlertDialog.vue'

    export default {
        name: 'DailyCheckMenuInputPreview',
        components: {
            PulseLoader,
            AlertDialog
        },
        props:{
            menuId: Number,
            subMenuId: Number,
        },
        computed: {
            brandId () {
                return this.$store.getters['brand/id']
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            pageId: function () {
                return this.$store.getters['preview/pageId']
            },
            dailyCheckPageName: function () {
                return this.$store.getters['preview/dailyCheckPageName']
            },
            dailyCheckItemNames: function () {
                let ruleList = [];
                this.$store.getters['preview/dailyCheckItemNames'].forEach(name => {
                    let item = {
                        value: false,
                        name: name
                    }
                    ruleList.push(item);
                })
                return ruleList;
            },
            arrangementRuleCount: function () {
                return this.$store.getters['preview/arrangementRuleCount']
            },
            allButtonDisplayFlg: function() {
                return this.$store.getters['preview/allButtonDisplayFlg']
            },
        },
        data() {
            return {
                isLoading: false,
                isInitLoading:true,
                isAllSelected: false,
                dailyCheckButtonName: "",
                page: 0,
                totalPage: 0,
                showModal: {
                    alertDisplay:false
                },
                commentDisplayFlg:[]
            };
        },
        created: function() {
            this.calc();
        },
        methods: {
            async calc() {
                let result = [];
                this.$store.getters['preview/dailyCheckItemCommentDisplayFlg'].forEach(function(value) {
                  result.push(value);
                })
                this.commentDisplayFlg = result;
                this.isInitLoading = true
                var datetime = this.dateFormat();

                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + this.menuId + '/page', {
                        params: {
                            datetime: datetime,
                            daily_check_button_id: this.subMenuId
                        }})
                    .then(response => {
                        this.dailyCheckButtonName = response.data.dailyCheckButtonName;
                        let pageCount = 0;
                        response.data.dailyCheckPageSettings.filter(setting => setting.displayFlg === 1).forEach(setting => {
                            pageCount++;
                            if (setting.dailyCheckPageId === this.pageId) this.page = pageCount;
                        })
                        this.totalPage = response.data.dailyCheckPageSettings.filter(setting => setting.displayFlg === 1).length + response.data.freeCommentFlg;
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: ''}
                            },
                            canBack: false
                        }
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

            },
            // チェックボタンクリック時
            selectItemClick(selectedItemId){
                this.dailyCheckItemNames[selectedItemId].value = !this.dailyCheckItemNames[selectedItemId].value;
            },
            selectAllCats () {
                if (this.isAllSelected) {
                    // 全て外す
                    this.dailyCheckItemNames.forEach(rule => {
                        rule.value = false;
                    });
                    this.isAllSelected = false;
                } else {
                    // 全てチェック
                    this.dailyCheckItemNames.forEach(rule => {
                        rule.value = true;
                    });
                    this.isAllSelected = true;
                }
            },
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            },
            openAlertModal() {
                this.showModal.alertDisplay = true;
            },
            closeAlertModal() {
                this.showModal.alertDisplay = false;
            },
            commentDisplayFlgToggle(index){
              // コメント追加ボタンクリック時
              var selectItem = this.commentDisplayFlg[index];
              var selectValue = this.commentDisplayFlg[index];
              switch (selectValue) {
                case 0:
                  selectItem = 1;
                  break;
                case 1:
                  selectItem = 0;
                  break;
              }
              this.commentDisplayFlg.splice(index,1,selectItem);
            },
        },
    }
</script>
